import InboundProduct from '@/components/dialogs/checker/receive'

export default {
  components: {
    InboundProduct
  },
  methods: {
    onInfoClose() {
      // this.$router.push("/order-centric");
    }
  }
}